/**
 * Store de edição do layout da Home (Zustand, SEM persistência).
 * Existe separado de `useHomeLayout` porque o menu mobile (Onda 4 — «Editar layout»)
 * precisa ativar o modo de edição de fora da página Início.
 */

import { create } from 'zustand'

interface HomeLayoutEditState {
  editing: boolean
  setEditing: (value: boolean) => void
}

export const useHomeLayoutStore = create<HomeLayoutEditState>((set) => ({
  editing: false,
  setEditing: (value) => set({ editing: value }),
}))
